import { IApplicant, ApplicantsService } from "../../../services/index";
import { IAuthUser } from "../../../authsettings/services/authusers.service";

class ApplicantsListController implements ng.IComponentController {
    
    private currentPage: number;
    private itemsPerPage: number;
    private sortType: string;
    private search: string;
    private applicants: IApplicant[];
    private filteredApplicants: IApplicant[];
    private preferredTargetAudiences: any;
    private functions: any;
    private users: IAuthUser[];
    functionFilter: any;
    targetAudienceFilter: any;
    statusFilter: any;
    applicationStatuses: any;
    userFilter: any;

    archive = false;

    constructor(
        private ApplicantsService: ApplicantsService,
        private $filter: any,
        private $stateParams: ng.ui.IStateParamsService,
        private $state: ng.ui.IStateService
    ) {
        'ngInject';
        this.sortType = 'displayName';
        //console.log('ApplicantsListController');
    }

    public $onInit = () => {
        if(this.$state.current.params.archive) {
            this.archive = true;
        }

        this.currentPage = 1;
        this.itemsPerPage = 11;
        this.getApplicants();

        this.statusFilter = '';


        if(this.$stateParams['status']) {

            if(this.$stateParams['status'] == 'all'){
                this.statusFilter = '';
            } else {
                this.statusFilter = this.applicationStatuses.find(s => s.code == this.$stateParams['status']).id;
            }
          
        }
        if(this.$stateParams['recruiter']) {
            this.userFilter = this.$stateParams['recruiter'];
        }
        if(this.$stateParams['function']) {
            this.functionFilter = this.$stateParams['function'];
        }
        if(this.$stateParams['targetaudiance']) {
            this.targetAudienceFilter = this.$stateParams['targetaudiance'];
        }
        // if(this.$stateParams['search']) {
        //     this.search = decodeURI(this.$stateParams['search']);
        // }
    }

    public filter = () => {
        var status = this.statusFilter ? this.applicationStatuses.find(s => s.id == this.statusFilter).code : 'all';
        if(this.archive) {
            this.$state.go('hr.applicants.archive', { 
                'recruiter': this.userFilter, 
                'status': status,
                'function': this.functionFilter,
                'targetaudiance': this.targetAudienceFilter,
                'search': encodeURI(this.search)
            });
        } else {
            this.$state.go('hr.applicants.list', { 
                'recruiter': this.userFilter, 
                'status': status,
                'function': this.functionFilter,
                'targetaudiance': this.targetAudienceFilter,
                'search': encodeURI(this.search)
            });
        }

    }

    public getApplicants = () => {
        if(this.archive) {
            this.ApplicantsService.getArchive().then(res => {
                this.applicants = res;
                this.applicants.forEach((applicant) => {
                    if(applicant.userId) {
                        var user = this.users.find(u => u.id == applicant.userId);
                        applicant.userName = user ? user.userName : '';
                    }
                })
                this.applyFilters();
            })
        } else {
            this.ApplicantsService.all().then(res => {
                this.applicants = res;
                this.applicants.forEach((applicant) => {
                    if(applicant.userId) {
                        var user = this.users.find(u => u.id == applicant.userId);
                        applicant.userName = user ? user.userName : '';
                    }
                })
                this.applyFilters();
            })
        }
       
    }

    applyFilters() {
        this.filteredApplicants = this.$filter('filterBy')(this.applicants, ['name', 'city'], this.search);
        this.filteredApplicants = this.$filter('filterBy')(this.filteredApplicants, ['functionId'], this.functionFilter);
        this.filteredApplicants = this.$filter('filterBy')(this.filteredApplicants, ['preferredTargetAudienceId'], this.targetAudienceFilter);
        if(this.statusFilter) {
            this.filteredApplicants = this.$filter('filterBy')(this.filteredApplicants, ['applicationStatusId'], this.statusFilter);
        }
        this.filteredApplicants = this.$filter('filterBy')(this.filteredApplicants, ['userId'], this.userFilter);
        this.filteredApplicants = this.$filter('orderBy')(this.filteredApplicants, this.sortType);
    }
}

export const applicantsListComponent = {
    bindings: {
        functions : "<",
        preferredTargetAudiences : "<",
        applicationStatuses: "<",
        users: "<"
    },
    controller: ApplicantsListController,
    template: require('./applicants.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/applicants/applicants.list.component.ts